import { Icon } from './Icon';

export type { TypeIconProps } from './types';
export default Icon;
